/*
 * @Description: 
 * @Author: xgx
 * @Date: 2023-07-31 15:02:40
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-28 10:59:07
 */
/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:00:41
 * @LastEditors: xgx
 * @LastEditTime: 2022-12-05 16:55:32
 */
import req from "@/utils/request";
export const tree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const findListLogPage = (params) => req.post("/interact-service/m/isApplyReport/findListLogPage", params);
export const selectList = (params) => req.post("/interact-service/m/isSiteOrganization/siteId", params);
export const isApplyReportOneStage = (params) => req.post("/interact-service/m/isApplyReportOneStage/save", params);
export const isApplyReportDeils = (params) => req.post("/interact-service/m/isApplyReport/id", params);
export const isApplyReportAdministrativeConfig = (params) => req.post("/interact-service/m/isApplyReportAdministrativeConfig/list", params);
export const saveTwo = (params) => req.post("/interact-service/m/isApplyReportTowStage/save", params);
export const typeList = (params) => req.post("/interact-service/m/isApplyReportAdministrativeConfig/tree", params);
export const saveThree = (params) => req.post("/interact-service/m/isApplyReportThreeStage/save", params);
export const deleteApplyReport = (params) => req.post("/interact-service/m/isApplyReport/deleteApplyReport", params);
export const deleteApplyReportIds = (params) => req.post("/interact-service/m/isApplyReport/deleteApplyReportIds", params);
export const findListPage = (params) => req.post("/interact-service/m/isApplyReport/findListPage", params);
export const updateType = (params) => req.post("/interact-service/m/isApplyReport/updateType", params);
export const findReportingAdministrativeStatistics = (params) => req.post("/interact-service/m/isApplyReport/findReportingAdministrativeStatistics", params);
export const findReportingStatistics = (params) => req.post("/interact-service/m/isApplyReport/findReportingStatistics", params);
export const applyReportStatisticsExport = (params) => req.down("/interact-service/m/isApplyReport/applyReportStatisticsExport", params);
export const selectListData = (params) => req.post("/manager-service/m/isSiteOrganization/selectList", params);
